module.exports = __webpack_public_path__ + "static/apple_store_badge-32112524fa047ec3c7f36f22d0995714.svg";